module.exports = __webpack_public_path__ + "static/img/com2.e4e9c10.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/views/product/components/imgs/com2.jpg
// module id = aRUm
// module chunks = 1